export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('page:transition:finish', () => {
    window.scrollTo(0, 0);
  });
});